import { useEffect, useRef } from "react";
import Seo from "@/components/Seo";

const POLICY_ID = "61586124";

function IubendaEmbed({ url, title }) {
  const containerRef = useRef(null);

  useEffect(() => {
    // Re-trigger iubenda embed processing when component mounts
    if (window._iub_e_lbl) {
      try { window._iub_e_lbl(); } catch (e) { /* noop */ }
    }
    // Fallback: dynamically reload iubenda.js if not already loaded
    if (!document.querySelector('script[src*="iubenda.com/iubenda.js"]')) {
      const s = document.createElement("script");
      s.src = "https://cdn.iubenda.com/iubenda.js";
      s.async = true;
      document.body.appendChild(s);
    } else if (window.iubendaParse) {
      try { window.iubendaParse(); } catch (e) { /* noop */ }
    }
  }, []);

  return (
    <div ref={containerRef} className="iubenda-policy-wrap">
      <a
        href={url}
        className="iubenda-white iubenda-noiframe iubenda-embed iub-body-embed"
        title={title}
      >
        {title}
      </a>
    </div>
  );
}

export function PrivacyPolicy() {
  return (
    <section className="section bg-lovac">
      <Seo title="Privacy Policy | Lovac" description="Informativa sul trattamento dei dati personali di Lovac ai sensi del GDPR." path="/privacy-policy" />
      <div className="container-narrow">
        <span className="badge-lovac">Legale</span>
        <h1 className="font-display text-4xl sm:text-5xl mt-5 text-lovac-dark leading-tight">
          Privacy Policy
        </h1>
        <div className="mt-12">
          <IubendaEmbed
            url={`https://www.iubenda.com/privacy-policy/${POLICY_ID}`}
            title="Privacy Policy"
          />
        </div>
      </div>
    </section>
  );
}

export function CookiePolicy() {
  return (
    <section className="section bg-lovac">
      <Seo title="Cookie Policy | Lovac" description="Informativa cookie del sito Lovac." path="/cookie-policy" />
      <div className="container-narrow">
        <span className="badge-lovac">Legale</span>
        <h1 className="font-display text-4xl sm:text-5xl mt-5 text-lovac-dark leading-tight">
          Cookie Policy
        </h1>
        <div className="mt-12">
          <IubendaEmbed
            url={`https://www.iubenda.com/privacy-policy/${POLICY_ID}/cookie-policy`}
            title="Cookie Policy"
          />
        </div>
      </div>
    </section>
  );
}
